module.exports = __webpack_public_path__ + "static/img/body1.13d30f9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body1.jpeg
// module id = KUOK
// module chunks = 1